import * as React from 'react';
import { useState, useRef, useCallback } from 'react';
import Map, { UseMap, NavigationControl, Source, Layer, MapProvider } from 'react-map-gl';


import DrawControl from './draw-control.tsx';
import ControlPanel from './control-panel.tsx';
import { Button,Tooltip, IconButton, Typography } from '@material-tailwind/react';
import * as turf from '@turf/turf';
import { CheckIcon, PencilIcon, XMarkIcon, XCircleIcon, ArrowUpCircleIcon, BeakerIcon, ChevronDoubleUpIcon, PrinterIcon,InboxArrowDownIcon, ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';


import {
  Timeline,
  TimelineItem,
  TimelineConnector,
  TimelineIcon,
  TimelineHeader,
} from "@material-tailwind/react";
import {
  BellIcon,
  ArchiveBoxIcon,
  CurrencyDollarIcon,
} from "@heroicons/react/24/outline";



const dataLayer = {
  id: 'data',
  type: 'fill',
  paint: {
    'fill-color': '#606060',
    'fill-opacity': 0.8
  }
};



/*
      <Source id="fc" type="geojson" data={props.features}>
        <Layer {...{
          id: 'polygonfill',
          type: 'fill',
          filter: ['all'],
          source: { 'type': 'vector' },
          paint: {
            'fill-color': {
              property: props.selected,
              stops: [
                [1, '#ff0000'],
                [10, '#00ff00']
              ]
            },
            'fill-opacity': 0.75
          }
        }} />

        <Layer {...{
          id: 'polygonlines',
          type: 'line',
          filter: ['all'],
          source: { 'type': 'vector' },
          paint: {
            'line-color': {
              property: props.selected,
              stops: [
                [1, '#ff0000'],
                [10, '#00ff00']
              ]
            },
            'line-width': 1
          }
        }} />
      </Source>

*/


var emptyGeoJson = {
  type: "FeatureCollection",
  features: []
}

const fillStyle2 = {
  id: 'polygonfill',
  type: 'fill',
  filter: ['all'],
  source: { 'type': 'vector' },
  paint: {
    'fill-color': '#ffff80', // yellow color fill
    'fill-opacity': 0.5
  }
};

const lineStyle = {
  id: 'polygonlines',
  type: 'line',
  filter: ['all'],
  source: { 'type': 'vector' },
  paint: {
    'line-color': {
      property: "value",
      stops: [
        [0, '#808080'],
        [1, '#00ff00'],
        [2, '#0000ff'],
        [3, '#ffff00'],
        [4, '#ff0000'],
        [5, '#c04000'],
        [10, '#802000']
      ]
    },
    'line-width': 2
  }
};

const fillStyle = {
  id: 'focuspolygonfill',
  type: 'fill',
  filter: ['all'],
  source: { 'type': 'vector' },
  paint: {
    'fill-color': {
      property: "value",
      stops: [
        [0, '#808080'],
        [1, '#00ff00'],
        [2, '#0000ff'],
        [3, '#ffff00'],
        [4, '#ff0000'],
        [5, '#993300'],
        [10, '#802000']
      ]
    },
    'fill-opacity': 0.6
  }
};

const timeStyle = {
  id: 'focuspolygonfill',
  type: 'fill',
  filter: ['all'],
  source: { 'type': 'vector' },
  paint: {
    'fill-color': {
      property: "value",
      stops: [
        [0, '#808080'],
        [1, '#00ff00'],
        [2, '#0000ff'],
        [3, '#ffff00'],
        [4, '#ff0000'],
        [5, '#993300'],
        [10, '#802000']
      ]
    },
    'fill-opacity': 0.6
  }
};



const polygonNameStyle = {
  id: "SectionTextLayer",
  type: "symbol",
  source: 'feat',
  paint: {
    "text-color": "white", //Color of your choice
  },
  layout: {
    "text-field": ['get','label'],
    "text-rotation-alignment": "auto",
    "text-allow-overlap": true,
    "text-anchor": "top"
  }
}




const geoFillStyle = {
  id: 'geoPolygonFill',
  type: 'fill',
  filter: ['all'],
  source: { 'type': 'vector' },
  paint: {
    'fill-color': '#00ffff', // lime fill
    'fill-opacity': 0.5
  }
};

const geoFineStyle = {
  id: 'geoPolygonLines',
  type: 'line',
  filter: ['all'],
  source: { 'type': 'vector' },
  paint: {
    'line-color': '#00ffff', //lime
    'line-width': 2
  }
};

const geoPolygonNameStyle = {
  "id": "geoSectionTextLayer",
  "type": "symbol",
  "source": "myfield",
  "paint": {
    "text-color": "white", //Color of your choice
  },
  "layout": {
    "text-field": ['get', 'polygonName'],
    "text-rotation-alignment": "auto",
    "text-allow-overlap": true,
    "text-anchor": "top"
  }
}


const initialView = {
  longitude: 15.62129,
  latitude: 53.63918,
  zoom: 11
};





export default function MapboxPanel(props) {

  const [boundingBox, setBoundingBox] = useState(props.boundingBox);
  const [style, setStyle] = useState(props.style || { position: 'relative', width: '46vw', height: '79vh', 'border-radius':'8px' })
  const [color, setColor] = useState(props.color);
  const [selected, setSelected] = useState(props.selected);
  const [min, setMin] = useState(props.min);
  const [max, setMax] = useState(props.max);
  const [med, setMed] = useState((props.max+props.min)/2 || 3);
  const [poor, setPoor] = useState((props.max+props.min)/3 || 2);
  const [good, setGood] = useState((props.max+props.min)/2 || 4);
  const [step, setStep] = useState((props.max-props.min)/4 || 1);
  
  const [showLegend, setShowLegend] = useState(props.showLegend);
  const [side] = useState(props.side);
  const [onEnlarge] = useState(props.onEnlarge);

  const [features, setFeatures] = useState(props.features);
  const [labFeatures, setLabFeatures] = useState(props.labFeatures);
  const [focused, setFocused] = useState({});
  const [results, setResults] = useState(props.results);
  
  const [showNumbers] = useState(props.showNumbers || false);
  const [seletedResults, setSelectedResults] = useState(0);
  //const [color, setColor] = useState('#ffff80')

  const mapRefPanel = useRef();


  React.useEffect(() => {
    /*  
    addEventListener('boundingBoxChanged', () => {
      console.log("bbox parse event");
      let bbox = JSON.parse(localStorage.getItem("boundingBox"));
      setMapBounds(bbox);
    });
    
    addEventListener('boundingBoxChangedPanel', (e) => {
      console.log("boundongbox event !!!!!!");
      if (e.detail) { setMapBounds(e.detail); }
    });

    addEventListener('featureCollectionChangedPanel', (e) => {
      if (mapRefPanel) 
      {
      if (e.detail.features) { console.log ("New features via event listener"); if (mapRefPanel?.current) { mapRefPanel.current.getSource("features").setData(e.detail.features); } 
                                  setFeatures(e.detail.features); }
       if (e.detail.labFeatures) { if (mapRefPanel?.current) { mapRefPanel.current.getSource("features").setData(e.detail.labFeatures);  }
                                  setLabFeatures(e.detail.labFeatures); }
       if (e.detail.focused) { if (mapRefPanel?.current) { mapRefPanel.current.getSource("focused").setData(e.detail.focused);  }
                                  setFocused(e.detail.focused); }
       if (e.detail.min) { recalculate(e.detail.min,e.detail.max); }
      }

        });

    */
    console.log("MAP RESTART");
    addEventListener('featureCollectionChangedPanel', quietFeaturesUpdate);
    addEventListener('labFeatureCollectionChangedPanel', quietLabFeaturesUpdate);
    addEventListener('boundingBoxChangedPanel', quietBBoxUpdate);
    addEventListener('selectedParameterChangedPanel', quietSelectedParamUpdate);
    addEventListener('minMaxChangedPanel', quietMinMaxUpdate);
    return () => {
      removeEventListener('featureCollectionChangedPanel',quietFeaturesUpdate);
      removeEventListener('labFeatureCollectionChangedPanel', quietLabFeaturesUpdate);
      removeEventListener('boundingBoxChangedPanel', quietBBoxUpdate);
      removeEventListener('selectedParameterChangedPanel', quietSelectedParamUpdate);
      removeEventListener('minMaxChangedPanel', quietMinMaxUpdate);
    }
    
    //console.log("bbox parse");    
    //let bbox = JSON.parse(localStorage.getItem("boundingBox"));
    //setTimeout(() => { setMapBounds(boundingBox); }, 250);
    //setBounds(boundingBox);
    
  }, []);

  React.useEffect(() => {
    /*
    console.log('Mapbox Features changed by Effect - skip');
    //setFeatures(props.features);
    //console.log(props.features);
    focusAll();

    if (mapRefPanel?.current) {
      mapRefPanel.current.zoomTo(mapRefPanel.current.getZoom());
      console.log('Rezoom');
    }
    */
  console.log('labFeatures changed by Effect');
    if (mapRefPanel?.current) {
      console.log('Rezoom');
      //mapRefPanel.current.zoomTo(mapRefPanel.current.getZoom());
    }
   
  
  }, [labFeatures]);


  React.useEffect(() => {
    console.log('features changed');
    setFeatures(props.features);
  }, [props.features]);



  React.useEffect(() => {
    console.log('selected changed by effect');
    console.log(props.selected);
    setSelected(props.selected);
  }, [props.selected]);


  
  React.useEffect(() => {
    console.log('results changed');  
    setResults(props.results);
  }, [props.results]);


  React.useEffect(() => {
      console.log('useEffect bbox changed');  
      console.log(props.boundingBox);  
      if (props.boundingBox)
      {
      setMapBounds(props.boundingBox);
      setTimeout(() => { setMapBounds(props.boundingBox); }, 25);
      }
    }, [props.boundingBox]);
  

  React.useEffect(() => {
    console.log('min max changed');  
    //recalculate(props.min,props.max); //czemu bez tego jest lepiej ?
  }, [props.min, props.max]);


function quietFeaturesUpdate(e) 
  {
    if (e.detail.features) { console.log ("New features via quiet event listener"); if (mapRefPanel?.current) { mapRefPanel.current.getSource("features").setData(e.detail.features); } 
                                  setFeatures(e.detail.features); }
  } 

  function quietBBoxUpdate(e) 
  {
    if (e.detail.bounds) { console.log ("New bbox via quiet event listener"); setMapBounds(e.detail.bounds); } 
                                  
  } 

  function quietLabFeaturesUpdate(e) 
  {
    if (e.detail.labFeatures) { console.log ("New lab features via quiet event listener");if (mapRefPanel?.current) { mapRefPanel.current.getSource("features").setData(e.detail.labFeatures);  }
                                  setLabFeatures(e.detail.labFeatures); }
  } 

  function quietSelectedParamUpdate(e) 
  {
    if (e.detail.selected) { console.log ("New selected parameter"); setSelected(e.detail.selected) }
  } 


  function quietMinMaxUpdate(e)
  {
    console.log("my side " + side);
    if (e.detail.min) { console.log ("recalculating " + e.detail.min + " " + e.detail.max + " side " + e.detail.side);   if(e.detail.side===side) recalculate(e.detail.min,e.detail.max); }
  }









function focusAll() {
          console.log("Map focusAll");
          console.log(features);
          if ((!features.type) || (!features.type=="FeatureCollection")) {
              console.log("Not a collection");
              return true;
            }
          let bounds = turf.bbox(features);
          let resizedbounds = resizeBoundingBox(bounds);
          setMapBounds(resizedbounds);
        }
  






  function resizeBoundingBox(bounds) {
    var point1 = turf.point([bounds[0], bounds[1]]);
    var point2 = turf.point([bounds[2], bounds[3]]);
    var bearing = turf.bearing(point1, point2);
    var distance = turf.distance(point1, point2);
    var p1 = turf.destination(point1, -0.2 * distance, bearing);
    var p2 = turf.destination(point2, 0.2 * distance, bearing);
    var box = [p1.geometry.coordinates[0], p1.geometry.coordinates[1], p2.geometry.coordinates[0], p2.geometry.coordinates[1]];
    return box;
  }




  function mapResize()
  {
    console.log("map resize");
    if (mapRefPanel.current !== null)  {
      console.log("ref resize");
      mapRefPanel.current.resize();
    }
  }

  function setMapBounds(bounds) {
    
    console.log("entering SetBounds " + bounds);
    if (bounds == null) return;
    if (mapRefPanel == null) return;
    if (mapRefPanel.current == null) return;
    console.log("mapref FitBounds " + bounds);
    mapRefPanel.current.fitBounds(bounds, { duration: 0 });
    

  }
  /*

  function setMapBounds(bounds) {
    console.log("SetMapBounds " + bounds);
    if (bounds == null) return;
    if (mapRefPanel == null) return;
    if (mapRefPanel.current == null) return;
    console.log("Reality check " + bounds);
    if ((mapRefPanel.current != null) && (bounds)) {
      mapRefPanel.current.fitBounds(bounds, { duration: 0 });
    }

  }
*/


  function printCanvas() {
    var dataUrl = mapRefPanel.current.getCanvas().toDataURL('image/png');
    var windowContent = '<!DOCTYPE html>';
    windowContent += '<html>'
    windowContent += '<head><title>Print canvas</title></head>';
    windowContent += '<body>'
    windowContent += '<img src="' + dataUrl + '">';
    windowContent += '</body>';
    windowContent += '</html>';
    const printWindow = window.open('', '_blank');
    printWindow.document.write(windowContent);
    printWindow.document.close();
    printWindow.print();

  }


  function downloadCanvas() {
    var dataUrl = mapRefPanel.current.getCanvas().toDataURL('image/png');
    let alink = document.createElement("a");
    //console.log(dataUrl);
    alink.href = dataUrl;
    alink.download = "mapa.png";
    alink.click();
    window.URL.revokeObjectURL(dataUrl);

  }

  /*
  function recalculate(min,max) {
    min=Number(min);
    max=Number(max);
    setMin(min);
    setMax(max);
    setMed((min+max)/2);
    setStep((max-min)/4); 
  }
  */

  function recalculate(min,max) {
    min=Number(min);
    max=Number(max);
    setMin(min);
    setMax(max);
    setMed((min+max)/2);
    setStep((max-min)/4); 
    setPoor(min+(max-min)/4);
    setGood(max-(max-min)/4);
  }



function timeConverter(timestamp){
  console.log("timestamp to conv");
  console.log(timestamp);
  var a = new Date(timestamp);
  if (!a.getFullYear()) { a = new Date(Number(timestamp)); } //try different way :)
  
  var months = ['stycznia','lutego','marca','kwietnia','maja','czerwca','lipca','sierpnia','września','października','listopda','grudnia'];
  var year = a.getFullYear();
  var month = months[a.getMonth()];
  var date = a.getDate();
  //var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
  var time = date + ' ' + month + ' ' + year 
  return time;
}


function handleChangeLabResults(e)
{
  console.log("results id");
  const resultsid = e.currentTarget.getAttribute("data-resultsid");
  console.log(resultsid);
  if (props.onChangeResults) props.onChangeResults(resultsid);
  setSelectedResults(resultsid);
}



function SamplingTimeline() {
  
  return (
    <div className="w-[14rem]">
      <Timeline>
        {results && results.map(({ id, title, date },index) => {
            const isLast = index === results.length - 1;
            const isSelected = Number(id) === Number(seletedResults);
            console.log ("is selected ? " + isSelected + " id= " +id + "  selectedR = " + seletedResults);
            const datestr=timeConverter(date);
            return(
        <TimelineItem key={id} className="h-16" data-resultsid={id} onClick={handleChangeLabResults}>
          {isLast==false && <TimelineConnector className="!w-[76px] "/>}
          <TimelineHeader className={`relative rounded-xl bg-black/50 hover:bg-blue-200/25 bold py-2 pl-4 pr-8 shadow-lg shadow-blue-gray-900/5  ${isSelected ? 'border border-blue-500' : ''}`} >
            <TimelineIcon className="p-3" color={`${isSelected ? 'green' : 'blue'} `}>
              <BeakerIcon className="h-4 w-4" />
            </TimelineIcon>
            <div className="flex flex-col gap-1">
              <Typography variant="small" color="white" className="text-md">
                {title}
              </Typography>
              <Typography variant="small" color="white" className="font-normal text-xs">
                {datestr}
              </Typography>
            </div>
          </TimelineHeader>
        </TimelineItem>
          )})}
      </Timeline>
    </div>
  );
}





  function applyPreviewImage(image) {
    //localStorage.setItem('previewImage', image);
    //dispatchEvent(new Event('previewImageChanged'));
  }

//if (!boundingBox) return(<></>);

  return (
    
    <Map
      ref={mapRefPanel}
      mapLib={import('mapbox-gl')}
      mapboxAccessToken="pk.eyJ1Ijoia2lsbGVyZWsiLCJhIjoiY21wcGpsdm5rMGYzZDJzczZ6dDB6MTBlYyJ9.puLzBeXZ_49KYthm2a_VfA"
      movingMethod="flyTo"
      mapStyle="mapbox://styles/mapbox/satellite-streets-v12"
      bounds={boundingBox}
      style={style}
      attributionControl={false}
      preserveDrawingBuffer={true}
    >
    
{/*
<Source id="feat" type="geojson" data={features}>
        <Layer {...timeStyle} />
        <Layer {...lineStyle} />
        <Layer {...polygonNameStyle} />
</Source>
*/}




<Source id="features" type="geojson" data={features}>
        <Layer {...{
          id: 'polygonfill',
          type: 'fill',
          filter: ['all'],
          source: { 'type': 'vector' },
          paint: {
            'fill-color': {
              property: selected,
              stops: [
                [min, '#804000'],
                [poor, '#ff0000'],
                [med, '#ffff00'],
                [good, '#0000ff'],
                [max, '#00ff00']
              ]
            },
            'fill-opacity': 0.7
          }
        }} />

        <Layer {...{
          id: 'polygonlines',
          type: 'line',
          filter: ['all'],
          source: { 'type': 'vector' },
          paint: {
            'line-color': {
              property: selected,
              stops: [
                [min, '#993300'],
                [poor, '#ff0000'],
                [med, '#ffff00'],
                [good, '#0000ff'],
                [max, '#00ff00']
              ]
            },
            'line-width': 2
          }
        }} />

        {showNumbers==true &&
        <Layer {...{
        id: "panelTextLayer",
        type: "symbol",
        source:  'features',
        paint: {
        "text-color": "white", //Color of your choice
              },
        layout: {
          "text-field": ["get", "label"],
          "text-rotation-alignment": "auto",
          "text-allow-overlap": true,
          "text-anchor": "top"
        }
        }} />

      }


      </Source>



{/*


      <Source id="focused" type="geojson" data={focused}>
        <Layer {...{
          id: 'focuspolygonfill',
          type: 'fill',
          filter: ['all'],
          source: { 'type': 'vector' },
          paint: {
            'fill-color': {
              property: props.selected,
              stops: [
                [min, '#ff0000'],
                [med, '#00ff00'],
                [max, '#0000ff']
              ]
            },
            'fill-opacity': 0.9
          }
        }} />


        <Layer {...{
          id: 'focuspolygonlines',
          type: 'line',
          filter: ['all'],
          source: { 'type': 'vector' },
          paint: {
            'line-color': {
              property: props.selected,
              stops: [
                [min, '#ffcccc'],
                [med, '#ccffcc'],
                [max, '#ccccff']
              ]
            },
            'line-width': 2
          }
        }} />

    
        </Source>
 */}    


      <div className='absolute bottom-2 right-16'>
        <Tooltip content="Drukuj mapę">
          <Button variant="filled" className='p-2 rounded-r-none bg-gray-100 hover:shadow-none hover:bg-blue-200' onClick={printCanvas} >
            <PrinterIcon className='w-4 h-4' color="black" />
          </Button>
        </Tooltip>
        <Tooltip content="Zapisz mapę">
          <Button variant="filled" className='p-2 rounded-l-none bg-gray-100 hover:shadow-none hover:bg-blue-200' onClick={downloadCanvas} >
            <InboxArrowDownIcon className='w-4 h-4' color="black" />
          </Button>
        </Tooltip>
      </div>

      <div className='flex flex-col absolute top-20 left-2 '>
        <SamplingTimeline />
        </div>


      {showLegend &&

      <div className='flex flex-col absolute top-14 right-2 '>
        <div className="flex rounded-top-md w-10 h-6 items-center bg-legend-min" >
        <Typography color="white" className="text-xs mx-auto mt-0.5 ">{min.toFixed(1)}</Typography>
        </div>
        <div className="flex w-10 h-3 bg-gradient-to-b from-legend-min to-legend-poor" ></div>


        <div className="flex rounded-none w-10 h-4 items-center bg-legend-poor" >
        <Typography color="white" className="text-xs mx-auto">{poor.toFixed(1)}</Typography>
        </div>
        <div className="flex w-10 h-3 bg-gradient-to-b from-legend-poor to-legend-med" ></div>

        <div className="flex rounded-none w-10 h-4 items-center bg-legend-med" >
        <Typography color="black" className="text-xs mx-auto">{med.toFixed(1)}</Typography>
        </div>

        <div className="flex w-10 h-3 bg-gradient-to-b from-legend-med to-legend-good" ></div>
        
        <div className="flex rounded-none w-10 h-4 items-center align-center bg-legend-good" >
          <Typography color="white" className="text-xs mx-auto">{good.toFixed(1)}</Typography>
        </div>

        <div className="flex w-10 h-3 bg-gradient-to-b from-legend-good to-legend-max" ></div>
        <div className="flex rounded-none w-10 h-6 mb-0.5 items-center bg-legend-max" >
        <Typography color="white" className="text-xs mx-auto">{(max).toFixed(1)}</Typography>
        </div>
      </div>
      }


    <NavigationControl position="bottom-right" />    
    </Map>

  );
}

